module.exports = __webpack_public_path__ + "img/72ne.af6d7946.svg";